<div class="app-es-ocr-quick-fix-shipping-tos">
  <div class="app-es-ocr-quick-fix-shipping-tos__row">
    <app-section-form-block-layout
      [formGroup]="formGroup"
      headerTitle="LABELS.SHIPPING_TERMS_OF_SALE"
      [isHeaderTitleUpperCase]="true"
      editBlockDescription="LABELS.FREIGHT_PAYMENT_HINT"
      infoTooltip="LABELS.FREIGHT_PAYMENT_HINT"
      [fields]="shippingTosFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(shippingTosFields, formGroup)"
      editBlockClass="normal-gap"
      (edit)="onShippingTermsBlockEdit($event)"
    >
      <div edit-block-header class="app-es-ocr-quick-fix-shipping-tos__body">
        <div class="app-es-ocr-quick-fix-shipping-tos__bl-type-container">
          <div
            *ngFor="let type of blControlTypes"
            class="card card-step app-es-ocr-quick-fix-shipping-tos__bl-type-container__card"
            [ngClass]="{ 'is-selected': typeControl.value === type }"
          >
            <div class="card-header">
              <app-radio-button
                [control]="typeControl"
                [id]="blTypeControlId(type)"
                [label]="blTypeControlLabel(type)"
                [value]="type"
                [name]="'bl-type'"
              ></app-radio-button>
            </div>
            <div class="card-body px-3">
              <span>{{ blTypeControlHint(type) | translate }}</span>
            </div>
          </div>
        </div>

        <p *ngIf="typeControl.value === enumChargesDistributionType.PREPAID" class="app-es-ocr-quick-fix-shipping-tos__text">
          {{ "LABELS.SHIPPING_TERMS_EXPORTER" | translate }}
        </p>

        <p *ngIf="typeControl.value === enumChargesDistributionType.COLLECT" class="app-es-ocr-quick-fix-shipping-tos__text">
          {{ "LABELS.IMPORTER_DESCRIPTION" | translate }}
          <br />
          {{ "LABELS.BL_TYPE_DESCRIPTION" | translate }}
        </p>
      </div>

      <p
        edit-block-footer
        *ngIf="typeControl.value === enumChargesDistributionType.PREPAID"
        class="app-es-ocr-quick-fix-shipping-tos__text pt-3 pl-2"
      >
        {{ "LABELS.BL_TYPE_DESCRIPTION" | translate }}
      </p>

      <div display-block-footer *ngIf="termsValidationMessages.length">
        <span class="text-error mb-1 d-block" *ngFor="let message of termsValidationMessages">
          {{ "BACK_ERROR." + message.text | translate }}
        </span>
      </div>
    </app-section-form-block-layout>
  </div>

  <missing-fields [code]="'LABELS.ENTRY_SUMMARY'" (decline)="onSubmit(false)"></missing-fields>
</div>
